import type { Nullable } from 'corgi-types';

import { DEFAULT_CHECKOUT_ERROR } from '../../../constants/checkout';
import type { ErrorMessage } from '../../../types/error';
import { getCheckoutErrorMessageKey } from '../../../utils/error-handlers/checkout';

export const getInitialError = (errorDetail: Nullable<string>): Nullable<ErrorMessage> => {
  if (errorDetail == null) {
    return null;
  }

  return {
    message:
      errorDetail === DEFAULT_CHECKOUT_ERROR
        ? errorDetail
        : getCheckoutErrorMessageKey(errorDetail),
    translated: false,
    timestamp: 0,
  };
};
